import { CURRENT_YEAR, ECompletionYearType } from '../../../constants/avaliableYears';
import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const yearGteDefinition = definitionFactory({
  key: 'yeargte',
  mapper: jsonQueryValue => [
    {
      label: 'Сдача в ' + (CURRENT_YEAR + ECompletionYearType.Later) + ' и позднее',
      value: jsonQueryValue,
    },
  ],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'yeargte', options);
  },
});
